import baseConfig from "./config.base";
import devConfig from "./config.dev";
import prevConfig from "./config.prev";
import prodConfig from "./config.prod";
import project from "@/config.json";

export type ConfigType = typeof baseConfig;

let config = {} as ConfigType;
let json = ["article", "banner"];

const commonMap = {
  development: `${window.origin}`,
  // preview: "https://common.mempool.com",
  preview: `${window.origin}`,
  // production: "https://common.mempool.com"
  production: `${window.origin}`,
};

const originMap = {
  development: "//192.168.0.4:9009",
  // development: "//192.168.1.2:7007",
  preview: "//124.71.26.46:58818",
  production: project.api_url,
};

let origin = "";
let originCommon = "";

if (process.env.NODE_ENV === "production") {
  config = { ...baseConfig, ...prodConfig };
  origin = originMap.production;
  originCommon = commonMap.production;
} else if (process.env.NODE_ENV === "preview") {
  config = config = { ...baseConfig, ...prevConfig };
  origin = originMap.preview;
  originCommon = commonMap.preview;
} else if (process.env.NODE_ENV === "development") {
  config = { ...baseConfig, ...devConfig };
  origin = originMap.development;
  originCommon = commonMap.development;
}

const whiteList = ["bsvTxidUrl", "btcTxidUrl", "getBchPrice", "getcode"]; //去除findMachine
Object.keys(config).forEach(function (key) {
  if (!whiteList.includes(key)) {
    if (json.includes(key)) {
      config[key] = originCommon + config[key];
    } else {
      config[key] = origin + config[key];
    }
  }
});
// console.log(config);

export default config;
